import { render, staticRenderFns } from "./ModalCloseButton.vue?vue&type=template&id=19c2d18a"
import script from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports